import { api, Api } from '../../services/api'
import { ISettingsDataHandler } from './ISettingsDataHandler'

interface IRequestSettingsResponse {
  'orders_refresh_interval': number
  'eta_refresh_interval':    number
  'store_id':                number
  'company_id':              number
  'store_name':              string
  'company_name':            string
  'default_language'?:       string | null
  'label_size'?:             string | null
}

export class SettingsDataHandler implements ISettingsDataHandler {
  api: Api
  _apiKey: string | null

  constructor() {
    this.api = api
    this._apiKey = null
  }

  async requestSettings(): Promise<{ storeName: string, refreshInterval: number, defaultLanguage: string | null, labelSize: string | null }> {
    const { data } = await this.api.client.get<IRequestSettingsResponse>('sra_dashboard_settings')

    const defaultLanguage =
      typeof data.default_language === 'string' && data.default_language.trim()
        ? data.default_language.trim()
        : null

    // Per-vendor label stock. Optional: the field does not exist yet on every
    // backend, so an absent value must read as "no opinion", not as a size.
    const labelSize =
      typeof data.label_size === 'string' && data.label_size.trim()
        ? data.label_size.trim()
        : null

    return {
      storeName: data.store_name,
      refreshInterval: data.orders_refresh_interval * 60 * 1000,
      defaultLanguage,
      labelSize,
    }
  }
}
